import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { useEditor } from '@/state/store'
import './styles.css'

// Dev-only: expose the store so the editor can be driven/seeded from the console (and MCP tests).
if (import.meta.env.DEV) {
  ;(window as unknown as { useEditor: typeof useEditor }).useEditor = useEditor
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
